import React from 'react';
import ReactDOM from 'react-dom/client';
import Configurator from './front/Configurator.js';

document.configuratorDisplay = function(node, options, config) {
	const root = ReactDOM.createRoot(node);
	root.render(
	  <React.StrictMode>
		<Configurator 
			options={options}
			onUpdate={config.onUpdate || null}
			setSubmits={config.setSubmits || null}
			setHashChangers={config.setHashChangers || null}
			profilesTitle={config.configurationProfilesTitle}
			profiles={config.configurationProfiles}
			adminMode={document.location.search === '?xxx'}
			updateUrlHash
			diplayTotals
			displayDescriptions
			renderHiddenInputs
			formatCurrency={config.formatCurrency || null}
			buttons={config.buttons || null}
			onSubmit={config.onSubmit || null}
		/>
	  </React.StrictMode>
	);
}